import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';

import * as paths from 'paths';
import AuthError from 'features/auth/containers/AuthError';
import Landing from 'features/root/containers/Landing';

const Routes: FC = () => (
  <Switch>
    <Route exact path={paths.authError} component={AuthError} />
    <Route component={Landing} />
  </Switch>
);

export default Routes;
